import { Phone } from "lucide-react";
import { Link } from "react-router-dom";

const PeerSupportDisclaimer = ({ className = "" }) => {
  return (
    <div className={`text-center py-4 px-4 bg-muted/30 border-t border-border ${className}`}>
      <p className="text-xs text-muted-foreground leading-relaxed max-w-3xl mx-auto">
        <strong>Disclaimer:</strong> VALORLink provides peer support only and does not offer medical, mental health, or emergency services.
        If you are in immediate danger, please contact{" "}
        <a href="tel:911" className="text-primary hover:underline font-medium">911</a> or the 
        Veterans Crisis Hotline (<a href="tel:988" className="text-primary hover:underline font-medium">988</a>, Press 1).
      </p>
      <p className="text-xs text-muted-foreground mt-2">
        <Link to="/safety-and-ethics" className="text-primary hover:underline font-medium" data-testid="footer-safety-ethics-link">Safety & Ethics</Link>
        <span className="mx-2 text-muted-foreground/50">|</span>
        <Link to="/contact" className="text-primary hover:underline font-medium" data-testid="footer-contact-link">Contact Us</Link>
      </p>
    </div>
  );
};

export default PeerSupportDisclaimer;
